export enum ROLES {
  SUPER_ADMIN = 'super_admin',
  ORG_ADMIN = 'org_admin',
  FINANCE = 'finance',
  COUNTRY_ADMIN = 'country_admin',
  TEAM_LEADER = 'team_leader',
  USER = 'user',
}
